module.exports = __webpack_public_path__ + "static/img/2019.298c486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2019.jpg
// module id = 3uMW
// module chunks = 1